const Routes = Object.freeze({
  ROOT: "/insights/",
  LOGIN: "login",
  LOGOUT: "logout",
  CALLBACK: "/callback",
  SELECT: "selected-type/",
  GENERAL_REPORT: "Export Data"
});

export { Routes };
